import React from 'react';

function LoginToUpdateFavorites() {
  return <p className="text-center">Please login to update your favorites.</p>;
}

export default LoginToUpdateFavorites;
